import React from 'react';
import { Link } from 'react-router-dom';

import './index.css';

const Component = (props) => {
    const { name, labRole, username, showBiography } = props;
    return (
        <div
            className="person-box col-sm-2 col-5"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/_static/people/${username}.jpg)`
            }}
        >
            <div className="person-info">
                <span className="person-name">{name}</span>
                <br />
                <span className="person-role">{labRole}</span>
            </div>

            {showBiography ? (
                <Link to={`${process.env.PUBLIC_URL}/people-profile/${username}`}>
                    <div className="person-link">
                        <i className="fas fa-external-link-alt" />
                    </div>
                </Link>
            ) : (
                ''
            )}
        </div>
    );
};

export default Component;
